UserService.$inject = ['API', 'Analytics', '_', '$rootScope', '$state', 'cfpLoadingBar', '$timeout', '$uibModalStack', 'Backoffice', 'disabled_features', 'Club'];

/* @ngInject */
function UserService(API, Analytics, _, $rootScope, $state, cfpLoadingBar, $timeout, $uibModalStack, Backoffice, disabled_features, Club) {
    var User = this;

    User.API = API.one('account');
    User.install = install;

    User.loggedIn = false;
    User.data = {};

    User.isAdmin = function () {
        return User.data.admin;
    };
    User.role = function () {
        if (!User.data.hasOwnProperty('role')) {
            return 999;
        }
        return User.data.role;
    };

    ////////////////

    User._stateChangeUnsubscribe = null;

    var permissions = {
        'OWNER': 1,
        'MANAGER': 2,
        'EMPLOYEE': 3,
        'MANAGER_WO_CODE': 4
    };

    /**
     * Evaluates the give role with the current user
     *
     * @method app.hasPermission
     * @param  {String} roleName
     * @return {Boolean}
     */
    User.hasPermission = function (roleName) {
        var role = permissions[roleName.toUpperCase()] || null;
        if (role === null) {
            return Backoffice.canPerform(roleName);
        }
        if (User.isAdmin() || User.role() === 1) {
            return true;
        }

        return User.role() <= role;
    };

    /**
     * Change the role of the current user
     * @method app.changeRole
     * @param  {{userId: Number, newRole: Number}} user
     * @return {void}
     */
    User.changeRole = function (user) {
        if (user.userId !== User.data.id) return;
        User.data.role = user.newRole;
        return;
    }

        /**
     * Evaluates the give role with the current user
     *
     * @method app.hasRole
     * @param  {String} roleName
     * @return {Boolean}
     */
    User.hasRole = function (roleName) {
        var role = permissions[roleName.toUpperCase()] || null;

        if (role === null) {
            return false;
        }
        return User.role() === role;
    };
    $rootScope.app.hasPermission = User.hasPermission;
    $rootScope.app.isFeatureEnabled = (feature) => !disabled_features.includes(feature);

    $rootScope.$on('$stateChangeStart', function (e, to) {
        if (!User.loggedIn) {
            return;
        }

        if (User.isAdmin()) {
            return;
        }

        if (to.role && User.role() > to.role) {
            // Violating access
            e.preventDefault();
            var targetState = Club.hasNewBookingsCalendarEnabled() ? 'app.grid' : 'app.bookings';
            $state.go(targetState);
            $timeout(cfpLoadingBar.complete, 100);
        }
    });

    /**
     * Install the User (by login or by remembered session)
     * @method install
     * @param  {Object} userdata
     */
    function install(userdata) {
        if (!userdata) {
            User.loggedIn = false;
            return;
        }

        User.loggedIn = true;
        _.extend(User.data, userdata || {});

        Analytics.set('&uid', userdata.id);

        $rootScope.$broadcast('user:login');
    }

    /**
     * @method logout
     */
    function logout() {
        User.data = {};
        User.loggedIn = false;
        Analytics.set('&uid', null);
        API.updateCSRF();
    }

    User.logout = logout;
    
}

export default UserService;